import React from 'react'
import PropTypes from 'prop-types'

class DateOfBirthTr extends React.Component {
  render() {
    var dateOfBirth = moment(this.props.fieldValue).format('M/D/YYYY')
    var age = moment().diff(this.props.fieldValue, 'years')

    return(
      <tr>
        <th>
          {this.props.fieldName}
        </th>
        <td>
          {this.props.fieldValue ? (
            <span>
              {dateOfBirth} ({age} Years Old)
            </span>
          ) : (
            '-'
          )}
        </td>
      </tr>
    )
  }
}

DateOfBirthTr.propTypes = {
  fieldName: PropTypes.string,
  fieldValue: PropTypes.string
}

export default DateOfBirthTr
